module.exports = __webpack_public_path__ + "static/media/greenExamAnalysis.59de28d2.svg";